import React from 'react'
import DynamicForm from 'views/ScanSettings/NewScan/components/DynamicForm'
import { FILTER_CONDITION, FILTER_NAME, FILTER_TYPE, FILTER_VALUE, RULE_FILTERS, SUCCESS } from 'views/ScanSettings/NewScan/constants'
import FilterForm from 'views/ScanSettings/components/FilterForm'
import { validateFilters } from '../steps/validate';

const Filters = ({ form, filters, onAddNewFilter, showNameField, setValidationError }) => {
	let formFields = [FILTER_NAME, FILTER_TYPE, FILTER_CONDITION, FILTER_VALUE]
	  
	const onRemoteValidation = async (values) => {		
		let failureResponse = await validateFilters([values]);
		return  failureResponse ? failureResponse : SUCCESS;
	}

	return (
		<DynamicForm
			remoteValidation={async (values) => await onRemoteValidation(values)}
			form={form}
			dataList={filters}
			dataType={RULE_FILTERS}
			dataTypeText="Filters"
			formFields={formFields}
			nameProp={FILTER_NAME}
			onAddNewItem={onAddNewFilter}
			setValidationError={setValidationError}
		>
			<FilterForm showNameField={showNameField} form={form} />
		</DynamicForm>
	)
}

export default Filters
